import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { LayoutGrid } from 'lucide-react';
import { Skeleton } from '../../components/ui/skeleton';
import { ViewCard } from '../../components/view-card';
import { sessionQuery, viewsQuery } from '../../lib/queries';

export const Route = createFileRoute('/_auth/views')({
  component: ViewsPage,
});

function ViewsPage() {
  const { data: session } = useQuery(sessionQuery);
  const { data: viewsData, isLoading } = useQuery(viewsQuery);

  const views = viewsData?.views ?? [];
  const role = session?.role ?? 'viewer';

  if (isLoading) {
    return (
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <Skeleton className="h-8 w-40" />
          <Skeleton className="h-9 w-28" />
        </div>
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <Skeleton className="h-72" />
          <Skeleton className="h-72" />
          <Skeleton className="h-72" />
          <Skeleton className="h-72" />
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Views</h1>
        <a
          href="https://claude.ai"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 rounded-lg bg-ndd-700 px-4 py-2 text-sm font-semibold hover:bg-ndd-600"
        >
          <LayoutGrid size={16} />
          New View
        </a>
      </div>

      {views.length === 0 ? (
        <div className="rounded-lg border border-dashed border-ndd-800 px-6 py-16 text-center">
          <p className="text-ndd-400">No views yet.</p>
          <p className="mt-1 text-sm text-ndd-600">
            Ask Claude to create one!{' '}
            <a
              href="https://claude.ai"
              target="_blank"
              rel="noopener noreferrer"
              className="text-ndd-400 hover:text-ndd-300 underline"
            >
              Open Claude →
            </a>
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          {views.map((view) => (
            <ViewCard key={view.view_id} view={view} role={role} />
          ))}
        </div>
      )}
    </div>
  );
}
